import React from "react";
import {connect} from "react-redux";
import {Col, Container, Row} from "react-bootstrap";
import {ErrorMessage, LoadingBoton} from "../../../../_helpers";
import http from '../../../../_services/cart/http.service';
import alertService from "../../../../_services/cart/alert.service";
import {Field, Form, Formik} from "formik";
import ReactStars from "react-rating-stars-component";
import * as Yup from 'yup';

class ReviewModal extends React.Component {

    state = {
        grabando: false
    }

    componentDidMount() {

    }


    render() {
        let inic = {
            rating: 5,
            observation: ''
        };

        const validationSchema = Yup.object().shape({
            observation: Yup.string().min(8, 'El password debe contener al menos 8 caracteres').max(300, 'Demasiado largo').required('Requerido'),
            rating: Yup.number().required('Requerido')
        });

        return (
            <>
                <Container>

                    {this.props.readonly &&

                    <Row>
                        <Col sm={12}>
                            <label htmlFor="password">Rating:</label>
                            <div className="input-group">
                                <ReactStars
                                    count={5}
                                    value={this.props.venta.review.rating}
                                    isHalf={true}
                                    edit={false}
                                    size={24}
                                    activeColor="#ffd700"
                                />
                            </div>
                        </Col>

                        <Col sm={12}>
                            <label htmlFor="observation">Comentario:</label>
                            <div className="input-group">
                                {this.props.venta.review.observation}
                            </div>
                        </Col>
                    </Row>
                    }


                    {!this.props.readonly && <Formik
                        enableReinitialize={true}
                        initialValues={inic}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            this.setState({grabando: true});

                            values.venta = {
                                id: this.props.venta.id
                            }

                            http.post('/api/ventas/review/save', values).then(
                                data => {
                                    alertService.msg('Review hecha exitosamente. Gracias por tomarte el tiempo para realizarla!');
                                    this.setState({grabando: false});
                                    this.props.handleClose();
                                },
                                error => {
                                    alertService.error(error)
                                    this.setState({grabando: false});
                                }
                            );
                        }}>
                        {({errors, touched, values, handleSubmit, setFieldValue}) => (
                            <Form>
                                <Row>
                                    <Col sm={12}>
                                        <label htmlFor="rating">Rating:</label>
                                        <div className="input-group">
                                            <ReactStars
                                                isHalf={true}
                                                value={5}
                                                edit={true}
                                                onChange={(val => {
                                                    setFieldValue('rating', val)
                                                })}
                                                size={24}
                                                activeColor="#ffd700"
                                            />
                                            <ErrorMessage name={`rating`}/>
                                        </div>
                                    </Col>

                                    <Col sm={12}>
                                        <label htmlFor="observation">Comentario:</label>
                                        <div className="input-group w-100">
                                            <Field type={"textarea"} className="w-100" name="observation"/>
                                            <ErrorMessage name={`observation`}/>
                                        </div>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col sm={12} className="text-center">
                                        <button className="btn btn-primary" type="submit"
                                                disabled={this.state.grabando}>
                                            Recomendar
                                            <LoadingBoton grabando={this.state.grabando}/>
                                        </button>
                                    </Col>
                                </Row>

                            </Form>
                        )}
                    </Formik>}

                </Container>
            </>
        );
    }
}

function mapState(state) {
    const {} = state;
    return {};
}

const actionCreators = {};

const connectedReviewModal = connect(mapState, actionCreators)(ReviewModal);
export {connectedReviewModal as ReviewModal};
